// extracted by mini-css-extract-plugin
export default {"fullWidth":"dn-z","image":"en-z","lazyLoadPicture":"fn-z","lazyLoadSpinner":"gn-z","lazyLoadSpin":"hn-z","lazyLoadImage":"in-z","hasStyledAspectRatio":"jn-z"};